module.exports = __webpack_public_path__ + "img/二维码_河源.141a3d5b.png";